import { LocalStorageKey } from '../constants/localStorageKeys';
import { UtilitiesService } from '../services/utilitiesService';
import { clearOpenPanel } from '../helpers/openPanelHelper';
import { clearCustomerIo } from '../helpers/customerIoHelper';
import { RegionService } from '../services/regionService';
import { RegionTypes } from '../config/regions';

export const signOut = () => {
	clearOpenPanel();
	clearCustomerIo();
	const clearStorageKeysByPrefix = (storage, prefix) => {
		try {
			const keys = [];
			for (let i = 0; i < storage.length; i += 1) {
				const k = storage.key(i);
				if (k && k.startsWith(prefix)) keys.push(k);
			}
			keys.forEach((k) => storage.removeItem(k));
		} catch (_) {
			// ignore
		}
	};

	const utilitiesService = new UtilitiesService();

	const isSa = new RegionService().currentRegion() === RegionTypes.SaudiArabia;
	const tokenKey = isSa ? LocalStorageKey.token_sa : LocalStorageKey.token_ae;
	const refreshTokenKey = isSa
		? LocalStorageKey.refreshToken_sa
		: LocalStorageKey.refreshToken_ae;
	const refreshTokenExpiryKey = isSa
		? LocalStorageKey.refreshTokenExpiresAt_sa
		: LocalStorageKey.refreshTokenExpiresAt_ae;

	utilitiesService.removeLocalStorage({ item: LocalStorageKey.users });
	utilitiesService.removeLocalStorage({ item: tokenKey });
	utilitiesService.removeLocalStorage({ item: refreshTokenKey });
	utilitiesService.removeLocalStorage({ item: refreshTokenExpiryKey });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.token }); // legacy fallback
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.systemSettings });
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.loadAllCollection,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.investorsCollections,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.borrowersCollections,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.notificationType,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.registrationInfo,
	});
	utilitiesService.removeLocalStorage({
		item: LocalStorageKey.registrationData,
	});
	utilitiesService.removeLocalStorage({ item: 'guideStepCount' });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.nafathVerified });
	utilitiesService.removeLocalStorage({ item: 'sessionExpired' });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.userLoggedInFirstTime });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.isKSApopup });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.checkPointServey });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.myOrders });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.userContactNumber });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.userPersonalInfo });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.depositPopup });
	utilitiesService.removeLocalStorage({ item: LocalStorageKey.isTermsDone });

	sessionStorage.removeItem(LocalStorageKey.activeLoanId);

	clearStorageKeysByPrefix(sessionStorage, 'fs_lean_connect_pending');
	clearStorageKeysByPrefix(localStorage, 'fs_lean_connect_pending');
};